module.exports = __webpack_public_path__ + "static/media/1009410.a0b2ccbd.png";